// extracted by mini-css-extract-plugin
export default {"container":"Fhr2U7qS","inner":"qyVfEdOR"};